export const countryLocator = () => {
  const countryList: { [key: string]: 'telegram' | 'wechat' | 'line' | 'whatsapp' } = {
    'UA': 'telegram',
    'RU': 'telegram',
    'BY': 'telegram', // Беларусь
    'AZ': 'telegram', // Азербайджан
    'AM': 'telegram', // Армения
    'KZ': 'telegram', // Казахстан
    'KG': 'telegram', // Кыргызстан
    'MD': 'telegram', // Молдова
    'TJ': 'telegram', // Таджикистан
    'TM': 'telegram', // Туркменистан
    'UZ': 'telegram', // Узбекистан
    'CN': 'wechat',
    'TH': 'line',
    'JP': 'line',
    'EU': 'whatsapp', // Европа
    'AF': 'whatsapp', // Африка
    'LATAM': 'whatsapp', // Латинская Америка
    'APAC': 'whatsapp', // Азия
  };
  
  // Дополнительные группы стран для Европы и APAC
  const europeanCountries = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'NO', 'DK', 'FI', 'GB'];
  const apacCountries = ['CN', 'JP', 'IN', 'SG', 'KR', 'MY', 'TH', 'VN', 'PH', 'ID'];
  
  const countryCode: string = navigator.language.split('-')[1];
  
  let region = 'whatsapp';
  
  if (europeanCountries.includes(countryCode)) {
    region = 'EU'; 
  } else if (apacCountries.includes(countryCode)) {
    region = 'APAC'; 
  } else {
    region = countryList[countryCode] || 'whatsapp'; 
  }
  
  return region;
}